import nl from './translations/nl.json';
import fr from './translations/fr.json';
import en from './translations/en.json';

export const defaultLocale = _getLocale();

export const languages = {
  nl,
  fr,
  en,
};

function _getLocale(){
  const lang = navigator.language;
  if(lang.toLowerCase().match('nl')){
    return 'nl';
  }
  else if(lang.toLowerCase().match('fr')){
    return 'fr';
  }
  return 'en';
}